import type { ChangeEvent, FocusEvent } from "react";

import { getSanitizedHtml } from "../../../handlers/utilityFunctions";
import { Label } from "../../ui/label";
import { NativeSelect } from "../../ui/native-select";

interface SelectOption {
	/** Optional: options without a value submit their text content, matching native <option> behavior. */
	value?: string;
	name: string;
}

interface SelectFieldProps {
	onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
	value?: string;
	id?: string;
	disabled?: boolean;
	name?: string;
	error?: string | null;
	label?: string;
	options?: SelectOption[];
	onFocus?: (e: FocusEvent<HTMLSelectElement>) => void;
}

function SelectField({
	onChange,
	value,
	id,
	disabled,
	name,
	error,
	label,
	options = [],
	onFocus = () => {},
}: SelectFieldProps) {
	return (
		<div className="space-y-1">
			{label && <Label className="text-sm">{label}</Label>}
			<NativeSelect
				name={name}
				id={id}
				value={value}
				onChange={onChange}
				onFocus={onFocus}
				disabled={disabled}
				aria-invalid={!!error}
			>
				{options.map((option, index) => (
					<option value={option.value} key={index}>
						{option.name}
					</option>
				))}
			</NativeSelect>
			{error && <div className="text-sm font-medium text-red-500">{getSanitizedHtml(error)}</div>}
		</div>
	);
}

export default SelectField;
